'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = exports.TableHeadCell = exports.TableHead = exports.TableFoot = exports.TableCell = exports.TableBody = exports.Table = undefined;

var _SpruceComponent = require('stampy/lib/util/SpruceComponent');

var _SpruceComponent2 = _interopRequireDefault(_SpruceComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = exports.Table = (0, _SpruceComponent2.default)('Table', 'table');
var TableBody = exports.TableBody = (0, _SpruceComponent2.default)('Table_body', 'tbody');
var TableCell = exports.TableCell = (0, _SpruceComponent2.default)('Table_cell', 'td');
var TableFoot = exports.TableFoot = (0, _SpruceComponent2.default)('Table_foot', 'tfoot');
var TableHead = exports.TableHead = (0, _SpruceComponent2.default)('Table_head', 'thead');
var TableHeadCell = exports.TableHeadCell = (0, _SpruceComponent2.default)('Table_headCell', 'th');
var TableRow = exports.TableRow = (0, _SpruceComponent2.default)('Table_row', 'tr');


//////////////////
// WEBPACK FOOTER
// ./~/react-goose/lib/shape/Table.js
// module id = 143
// module chunks = 35783957827783 114276838955818 162898551421021